import { render } from "./ReviewSetting.vue?vue&type=template&id=72def9e0&scoped=true"
import script from "./ReviewSetting.vue?vue&type=script&lang=js"
export * from "./ReviewSetting.vue?vue&type=script&lang=js"

import "./ReviewSetting.vue?vue&type=style&index=0&id=72def9e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72def9e0"]])

export default __exports__